export default __webpack_public_path__ + "static/team-image-1-d1e7e4569f9e41a2c137832c947bd563.png";